<template>
    <div :style="theme">
        <layout v-bind:settingsConfig="settingsConfig" v-bind:config="config">
                <div id="spacer"></div>

                <div class="glide" v-if="foContent.slide">
                    <div class="glide__track" data-glide-el="track">
                        <ul class="glide__slides">
                            <li class="glide__slide" v-for="(slide, index) in foContent.slide.filter(elt => elt.content)" :key="index">
                                <img :src="slide.content" :alt="slide.title" class='slide-image'>
                            </li>
                        </ul>
                        <div v-if="slogan" class="slide_cover">
                            {{slogan}}
                        </div>
                    </div>
                </div>


                <div class="container main-content" v-if="foContent.main">
                    <section class="section" v-for="(content, index) in foContent.main" :key="index">
                        <h1 class="title is-spaced has-text-centered ">{{content.title}}</h1>
                        <div class="content" v-html="content.content"></div>
                    </section>
                </div>

                <section class="container block">
                    <h1 class="title is-spaced has-text-centered">Prendre rendez-vous</h1>
                    <div class="columns is-desktop is-variable is-8" id="prise-rdv">
                        <div class="column is-half" v-if="!config.disabled_fo_signin">
                            <div class="box action-rdv-box">
                                <div class="title">En ligne</div>
                                <div class="columns is-flex-grow-1">
                                    <div class="column is-one-third">
                                        <img src="/assets/images/homepage/rdv_en_ligne.png" alt="">
                                    </div>
                                    <div class="column is-flex is-flex-direction-column is-justify-content-space-between">
                                        <p>Prenez directement rendez-vous en ligne en toute simplicité !</p>
                                        <div class="buttons is-flex is-justify-content-flex-end buttons-box-action">
                                            <button id="book-online-button" class="button is-info is-large" @click="$inertia.get('/ressources')">Prendre rdv</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="phoneButtonRef != '#'" class="column is-half">
                            <div class="box action-rdv-box">
                                <div class="title">Contact</div>
                                <div class="columns  is-flex-grow-1">
                                    <div class="column is-one-third">
                                        <img src="/assets/images/homepage/rdv_tel.png" alt="" class="column">
                                    </div>
                                    <div class="column is-flex is-flex-direction-column is-justify-content-space-between">
                                        <p>Appelez notre secrétariat pour prendre rendez-vous .</p>
                                        <div class="buttons is-flex is-justify-content-flex-end buttons-box-action">
                                            <a class="button is-ghost has-text-info is-large" :href="phoneButtonRef">
                                                Appeler
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section class="container py-5" v-if="locations.length > 0">
                    <h1 class="title has-text-centered">{{locations.length > 1 ? 'Adresses' : 'Adresse'}}</h1>
                    <div class="columns is-multiline is-variable is-8">

                        <div class="column is-one-third-desktop is-full-mobile px-5" v-if="map">
                            <div id="mapid" class="container"></div>
                        </div>

                        <div class="column is-full-mobile locations-container" id="locations-container">
                            <div v-for="(location, index) in locations" :key="index">

                                <hr v-if="index != 0">

                                <div class="section columns py-3">
                                    <div class="column is-narrow" v-if="location.image && getLocationImagePath(location)">
                                        <img :src="getLocationImagePath(location)" alt="">
                                    </div>
                                    <div class="column" id="locations-informations-container">
                                        <p class="is-size-5 has-text-weight-bold">{{location.name}}</p>
                                        <p><b>Adresse : </b> {{renderLocationAddress(location)}}, {{location.city}} {{location.zip_code}} </p>
                                        <p v-if="location.phone">
                                            <b>Numéro de téléphone : </b>
                                            <a
                                                :href="'tel:' + location.phone"
                                                class="location-phone-number"
                                                :id="`location-${location.location_id}-phone-number`"
                                            >
                                                {{location.phone}}
                                            </a>
                                        </p>
                                        <details>
                                            <summary class="has-text-info is-underlined is-clickable">Voir les horaires</summary>
                                            <div class="details-content">
                                                <div v-for="(day, index) in location.days" :key="index">
                                                    <b>{{day.day}} : </b>{{day.hours}}
                                                </div>
                                            </div>

                                        </details>
                                        <p
                                            class="has-text-info is-underlined is-clickable"
                                            v-if="getLocationPosition(location)"
                                            @click="moveMapToLocation(location)"
                                        >Afficher sur la carte</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </section>



        </layout>
    </div>
</template>

<script>
import layout from './Layout'
import Glide from '@glidejs/glide'

export default {
    components : {layout},
    computed: {
        phoneButtonRef () {
            if (!this.locations.find(location => location.phone)) return '#'

            let phone_numbers = this.locations.filter(location => location.phone).map(location => location.phone)
            // deduplicate numbers
            phone_numbers = [...new Set(phone_numbers)]

            if (phone_numbers.length > 1) return '#locations-informations-container'

            let location = this.locations.find(location => location.phone)

            return `tel:${location.phone}`
        },
        theme(){
            return this.fo_config['theme'];
        }
    },
    props: ['config', 'settingsConfig', 'fo_config', 'foContent', 'logo', 'days', 'locations', 'slogan', 'cdn_subdomain'],
    data () {
        return {
            map: {}
        }
    },
    methods: {
        attachCarousel () {
            let slides = this.foContent.slide.filter(slide => slide.content)
            let slides_to_display = Math.min(3, slides.length)
            let options = {
                autoplay: 2000,
                animationDuration: 1000,
                animationTimingFunc: 'ease-out',
                bound: true,
                breakpoints : {
                    769: {
                        perView: 2
                    },
                    480: {
                        perView: 1
                    }
                },
                gap: 0,
                perView: slides_to_display,
                rewindDuration: 2000,
                type: 'carousel',
            }
            new Glide('.glide', options).mount()
        },
        attachMap() {
            let default_map_location = this.locations.find(location => location?.geo?.lat && location?.geo?.lon)
            /*
            * S'il n'y a aucune localisation à afficher on masque la carte
            */
            if (!default_map_location) {
                this.map = null
                return false
            }

            let pos = [default_map_location.geo.lat, default_map_location.geo.lon];

            this.map = L.map('mapid').setView(pos, 15);
            L.tileLayer('/osm.php?z={z}&x={x}&y={y}', {
                maxZoom: 19,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);

            for (let location of this.locations) {
                if (location?.geo?.lat && location?.geo?.lon) L.marker([location?.geo?.lat, location?.geo?.lon]).addTo(this.map);
            }
        },
        getLocationImagePath(location) {
            let host = window.location.hostname.split('.')
            if (!host[1]) return false

            return `https://${this.cdn_subdomain}.${host[1]}.${host[2]}/datas/${host[0]}/images/locations/${location.image}`
        },
        getLocationPosition(location) {
            if (!location?.geo?.lat || !location?.geo?.lon) return null

            return [location?.geo?.lat, location?.geo?.lon]
        },
        moveMapToLocation(location) {
            this.map.setView(this.getLocationPosition(location), 15)

            let map = document.querySelector("#mapid")
            if (map) map.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        },
        renderLocationAddress(location) {
            if (!location.address) return ''
            let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
            return location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
        },
        setBodyStyle(){
            document.body.style.backgroundColor = this.theme['--body-bg-color'];
        }
    },
    mounted () {
        this.setBodyStyle();
        if (this.foContent.slide) this.attachCarousel()
        this.attachMap()
    }
}
</script>

<style>
    #book-online-button {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }

    #book-online-button:hover {
        background-color: var(--btn-primary-bg-color-hover);
        color: var(--btn-primary-text-color);
    }
</style>
